import EventEmitter from 'owa-event-emitter';

/**
 * Exporting Various event names to be emitted from the DAL layer to inform the CalendarSurfaceStore about any changes in the events cache
 */
export const eventEmitter = new EventEmitter(); // Creating an instance of EventEmitter
export const eventsAdded = 'eventsAdded'; // Event Name for adding calendar events
export const eventsRemoved = 'eventsRemoved'; // Event Name for removing calendar events
export const cacheReloaded = 'cacheReloaded'; // Event triggered on cache reload
